import Proptypes from 'prop-types'
import dynamic from 'next/dynamic'
import { isPartVisible } from 'utils/displayByDateAndTime'
import { useOnlineStatus } from '../../../hooks/useOnlineStatus'
import PwaOfflinePlaceholder from 'components/PwaOfflinePlaceholder'

const GoogleForm = dynamic(import('components/GoogleForm'), { ssr: false })
const GoogleMapEmbed = dynamic(import('components/GoogleMapEmbed'), { ssr: false })

export const PartIntegrations = ({ part }) => {
  const online = useOnlineStatus()
  if (!online) {
    return <PwaOfflinePlaceholder />
  }

  if (!isPartVisible(part)) return null
  switch (part.type) {
    case 'FormGoogle':
      return <GoogleForm part={part} />
    case 'GoogleMaps': {
      return <GoogleMapEmbed part={part} />
    }
    default:
      return null
  }
}

PartIntegrations.propTypes = {
  part: Proptypes.object,
}

export default PartIntegrations
